module.exports = __webpack_public_path__ + "img/red_packet_bg.4a6605e9.png";